import React, { Component } from 'react';
import { connect } from 'react-redux';
import { QuantityPicker } from '../QuantityPicker';
import SizePicker from '../SizePicker';
import RaisedButton from 'material-ui/RaisedButton';
import { THIRD_COLOR } from '../../config/colors';
import CloseIcon from '../CloseIcon';

import './style.css';
import { productHasSizes, getTotalProductPrice, checkEmpty, getProductName, getClassificationClass, convertProductToCartItem } from '../../helpers/productHelper'
import { getItemQnt } from '../../reducers/cartReducer'
import LabDataValue from '../LabDataValue/lab_data_value';
import { getUomDisplayVal, isSize, isMedium, isMgDose, isTotalDose } from '../../helpers/attribute_util';
import { getStyle as getClassificationStyle } from '../../helpers/classification_util';
import { getColors } from '../../selectors/configSelectors';
var $ = require("jquery");

/*
  Prepresents small product view (1X view)
*/
const styles = {
  labelStyle: { fontWeight: 700 },
  closeIconWrap: {"position":"absolute","right":"10px", top: '10px' },
  closeIcon: {height:'35px', width:'35px', color: THIRD_COLOR },
}
class ProductShort extends Component {
  constructor(props) {
    super(props);
    this.state = {
      quantity: 1,
      sizeIndex: this.getProductIndexOfSmallestSize(this.props.product.productList.filter(size => { return size.priceSell > 0 })),
    }
  }

  isAttribute = (productType, attributeName) => {
      if (productType === 'CARTRDIGE' && attributeName === 'SIZE') {
          return false;
      } else if (productType === 'EXTRACT' && (attributeName === 'SIZE' || attributeName === 'SUBTYPE')) {
          return true;
      } else if (productType === 'EDIBLE' && (attributeName === 'MGDOSE' || attributeName === 'SUBTYPE' || attributeName === 'TOTALDOSES')) {
          return true;
      } else if (productType === 'PLANT' && (attributeName === 'MEDIUM' || attributeName === 'SIZE')) {
          return true;
      } else if (productType === 'PRE-ROLL' && attributeName === 'SIZE') {
          return true;
      } else if (productType === 'TOPICAL' && attributeName === 'MGDOSE') {
          return true;
      } else {
          return false;
      }
  }
  isLabResults = () => {
    const { product } = this.props;
    return this.isThc(product.thc, product.type) || this.isCbd(product.cbd, product.type) || this.isTerp(product.terps, product.type) || this.isCbdPercent(product.cbdPercent, product.type);
  }
   getPriceTag = (p, specificProduct) => {
        var isSize = productHasSizes(p.type);
        var priceWith = getTotalProductPrice(specificProduct, this.props.menuRoundTax);

        return { isSize, price: priceWith.toFixed(2) }
    }

    getProductIndexOfSmallestSize = (productList) => {
        // returns product Index of 3.5 size, or first smallest size
        var products = {};
        $.map(productList, function(e, i) {
            products[e.weight] = i;
        });
        var productIndex = -1;
        if ('3.5' in products) {
            productIndex = products['3.5'];
        } else {
            Object.keys(products).sort(function(a, b) {
                return Number(a) - Number(b);
            });
            // smallest size
            if (productList.length > 0)
                productIndex = 0;
        }
        return Number (productIndex);
    };
    onImgLoaded = () => {
      this.setState({
        ringSpinner: false
      })
    }

    imgError = (event) => {

    }
   handleQuantityChange = (quantity) => {
     this.setState({
       quantity: quantity
     })
   }
   handleSizeChange = (sizeIndex) => {
      this.setState({
       sizeIndex: sizeIndex
     })
   }
   isQuantity = () => {
    return this.props.product.type !== 'FLOWER';
   }
   isWeight = () => {
    return this.props.product.type === 'FLOWER';
   }
   handleAddToCart = () => {
      const sizeItem = this.props.product.productList[this.state.sizeIndex];

      this.props.onAddToCartClick(
        convertProductToCartItem(
          this.props.product,
          sizeItem,
          this.state.quantity,
        )
      );
   }
    /**
  moev to util class
  */
  isTerp = (value, type) => {
    if (type === 'EDIBLE') {
        return false;
    }
    return value && value !== '-.-' ? true : false;
}

  isCbdPercent = (value, type) =>  {
    if (type === 'EDIBLE') {
        return false;
    }
    return value && value !== '-.-' ? true : false;
}

 isThc = (value, type) =>  {
    if (type === 'EDIBLE') {
        return false;
    }
    return value && value !== '-.-' ? true : false;
}
 isCbd = (value, type) =>  {
    if (type === 'EDIBLE') {
        return false;
    }
    return value && value !== '-.-' ? true : false;
}

  setIndex = (value) => {
    this.setState({
      sizeIndex: value
    });
  }

  render() {
    const product = this.props.product;
    const brand = checkEmpty(product.brand);
    const name = getProductName(product);
    const classification = product.classifications.map((classification, index) =>
      <span key={index}
        className={`classification ` + getClassificationClass(product)}
        style={getClassificationStyle(classification, this.props.colors)}>
          {classification}
      </span>
    );
    const subTypes = product.subTypes.map((subType, index) =>
    {
     return <span key={subType} className="attribute">{subType}</span>
    }
      )
    const size = <span className="attribute">{product.size}</span>;
    const medium = <span className="attribute">{product.medium}</span>;
    const mgTotal = product.mgDose ? <span className="attribute">{product.mgDose} MG THC</span> : null;
    const mgDose = product.totalDoses > 0 ? <span className="attribute">{product.totalDoses} DOSES</span> : null;
    const sizes = product.productList.filter(size => { return size.priceSell > 0  });
    // return index of 3.5 G or nearest smallest size index
    const specificProduct = sizes[this.state.sizeIndex];

    const getPriceTagObj = this.getPriceTag(product, specificProduct);
    const priceTag = (getPriceTagObj) => (
        <div className="menu-item-pricetag" style={{"display":"flex",color:'#616161', "WebkitBoxAlign":"center","MsFlexAlign":"center","alignItems":"center"}}>
            <span className="dollar">$</span>
            <span style={{fontSize: '20px',fontFamily:'Futura-Bold'}}>{getPriceTagObj.price}</span>
            {getPriceTagObj.isSize && <span style={{margin: '4px 0 0 2px', fontSize: '11px'}}>{`/ ` + specificProduct.weight + getUomDisplayVal(specificProduct.unitOfMeasurement)}</span>}
        </div>
    )
    const unitsInCart = this.props.getQntInCart(specificProduct.productId);
    const maxUnits = specificProduct.unitsInStock - unitsInCart;
    return (
      <div className="menu-item-small" style={{margin:0}}>
        <div onClick={this.props.handleClose} style={styles.closeIconWrap}><CloseIcon style={styles.closeIcon} /></div>
        <div className="item">
          <div className="wrapper">
            <div style={{textAlign: 'left'}}>
              <div className="item-text-1 uppercase">{brand}</div>
              <div className="item-text-2 uppercase" style={{color:this.props.textColor}}>{name}</div>
              <div className="item-text-3 uppercase">
                {classification}
                {/*product.thc && product.thc != '-.-' && <span className="attribute">THC {product.thc}%</span>*/}
                {this.isAttribute(product.type, 'SUBTYPE') && subTypes.length && <span>{subTypes}</span>}
                {this.isAttribute(product.type, 'SIZE') && isSize(product) && <span>{size}</span>}
                {this.isAttribute(product.type, 'MEDIUM') && isMedium(product) && <span>{medium}</span>}
                {this.isAttribute(product.type, 'MGDOSE') && isMgDose(product) && <span>{mgDose}</span>}
                {this.isAttribute(product.type, 'TOTALDOSES') && isTotalDose(product) && <span>{mgTotal}</span>}
              </div>
              <div className="item-text-4">{priceTag(getPriceTagObj)}</div>
              <div className="labresults-wrapper" style={{display: this.isLabResults() ? '' : 'none', textAlign:'center'}}>
                {this.isThc(product.thc, product.type) && <span className="labresults"><span className="attribute"><LabDataValue name="THC" value={product.thc} /></span></span>}
                {this.isCbd(product.cbd, product.type) && <span className="labresults"><span className="attribute"><LabDataValue name="CBD" value={product.cbd} /></span></span>}
                {this.isTerp(product.terps, product.type) && <span className="labresults"><span className="attribute"><LabDataValue name="TERPS" value={product.terps} /></span></span>}
                {/*isCbdPercent(product.cbdPercent, product.type) && <div className="labresults">{`CBD ` + product.cbdPercent}<sup>%</sup></div>*/}
              </div>
            </div>
          </div>
        </div>
        { this.isQuantity() &&
          <div>
            <hr style={{margin: '5px 0'}}/>
            <QuantityPicker
              secondaryColor={this.props.secondaryColor}
              max={maxUnits}
              count={this.state.quantity}
              onChange={this.handleQuantityChange}
            />
          </div>
        }
        { this.isWeight() &&
          <SizePicker
            secondaryColor={this.props.secondaryColor}
            sizes={sizes}
            sizeIndex={this.state.sizeIndex}
            onChange={this.handleSizeChange}
            setIndex={this.setIndex}
          />
        }
        <hr style={{margin: '5px 0'}}/>
        <div style={{textAlign:'center', margin: '10px 0 0'}}>
          <RaisedButton
            disabled={maxUnits <= 0}
            onClick={this.handleAddToCart}
            backgroundColor={`#` + this.props.secondaryColor}
            labelColor="#FFF"
            label="Add To Cart"
            labelStyle={styles.labelStyle}
          />
         {/* <div style={{padding:'10px 0 0 0', color:`#` + this.props.secondaryColor, cursor:'pointer'}}>ADD MORE</div> */}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    getQntInCart: (productId) => getItemQnt(state, productId),
    textColor : state.config.textColor,
    primaryColor: state.config.primaryColor,
    secondaryColor: state.config.secondaryColor,
    menuRoundTax: state.config.menuRoundTax,
    colors: getColors(state),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {

  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ProductShort);



// WEBPACK FOOTER //
// ./src/components/ProductShort/ProductShort.jsx